export default __webpack_public_path__ + "static/register-1c3c61d6e8b10388138cd274aed57043.png";